import Constants from 'config/constants';
import Dispatcher from 'lib/dispatcher';

const ModalActions = {
  show(view, opts) {
    setTimeout(() => {
      Dispatcher.handleModalAction({
        actionType: Constants.SHOW_MODAL,
        view,
        opts: opts || {},
      });
    });
  },
  hide() {
    setTimeout(() => {
      Dispatcher.handleModalAction({
        actionType: Constants.HIDE_MODAL,
      });
    });
  },
};

export default ModalActions;
